import {request} from '../request';
import {DeploymentStatusInfo} from '../../types/deployment/DeploymentStatusInfo';

export const DeploymentStatusUrl = '/deployment/status';

export type DeploymentStatusRequest = {
  deploymentId: string;
};

export async function getDeploymentStatus(params: DeploymentStatusRequest) {
  return request<DeploymentStatusInfo>({
    method: 'get',
    url: DeploymentStatusUrl,
    params,
  });
}
